export const headersExcel = [
    {
        text: 'ID',
        value: 'id',
        sortable: true,
    },
    {
        text: 'ID CLIENTE',
        value: 'clientID',
        sortable: true,
    },
    {
        text: 'ID VEICULO',
        value: 'vehicleID',
        sortable: true,
    },
    {
        text: 'ID TECNICO',
        value: 'technicianID',
        sortable: true,
    },
    {
        text: 'ID EQUIPAMENTO',
        value: 'equipmentID',
        sortable: true,
    },
    {
        text: 'ID MODELO',
        value: 'modelID',
        sortable: true,
    },
    {
        text: 'ID USUARIO',
        value: 'accountID',
        sortable: true,
    },
    {
        text: 'DATA DE CRIACAO',
        value: 'createdDate',
        sortable: true,
    },
    {
        text: 'DESCRICAO',
        value: 'description',
        sortable: true,
    },
    {
        text: 'NOME DO CLIENTE',
        value: 'clientName',
        sortable: true,
    },
    {
        text: 'NOME DO TECNICO',
        value: 'technicianName',
        sortable: true,
    },
    {
        text: 'PLACA',
        value: 'plate',
        sortable: true,
    },
    {
        text: 'NOME DO EQUIPAMENTO',
        value: 'equipmentName',
        sortable: true,
    },
    {
        text: 'USUARIO',
        value: 'accountName',
        sortable: true,
    },
    {
        text: 'MODELO',
        value: 'model',
        sortable: true,
    },
];
